import React from 'react'

const SafetyFeatures = ({ report, onAnswer }) => {
  const services = (report.adas && report.adas.services) || []

  // Derive potential sensors from services — same logic as admin-portal
  const potentialSensors = []
  const seen = new Set()
  services.forEach(svc => {
    if (
      (svc.recommendedStatus === 'potential' || svc.sensorAnswer) &&
      !seen.has(svc.sensorName)
    ) {
      seen.add(svc.sensorName)
      potentialSensors.push({
        sensorName: svc.sensorName,
        sensorAnswer: svc.sensorAnswer || null,
      })
    }
  })

  // Only show unanswered sensors in "Requires Attention"
  const unanswered = potentialSensors.filter(s => !s.sensorAnswer)
  // Answered sensors go in "Safety Systems"
  const answered = potentialSensors.filter(s => s.sensorAnswer)

  if (potentialSensors.length === 0) return null

  return (
    <>
      {unanswered.length > 0 && (
        <div className='adas-detail__attention-card'>
          <div className='adas-detail__attention-header'>
            <h3 className='adas-detail__attention-title'>Requires Attention</h3>
            <p className='adas-detail__attention-subtitle'>
              Answering these questions will determine if &quot;Potential&quot; services are required.
            </p>
          </div>
          {unanswered.map((sensor, idx) => (
            <div key={sensor.sensorName} className='adas-detail__attention-question'>
              <span className='adas-detail__question-text'>
                {idx + 1}. Is the vehicle equipped with {sensor.sensorName}?
              </span>
              <div className='adas-detail__question-actions'>
                <div className='adas-detail__radio-group'>
                  <label className='adas-detail__radio'>
                    <input
                      type='radio'
                      name={`question-${sensor.sensorName}`}
                      value='yes'
                      checked={sensor.sensorAnswer === 'equipped'}
                      onChange={() => onAnswer && onAnswer(sensor.sensorName, 'equipped')}
                    />
                    <span>Yes</span>
                  </label>
                  <label className='adas-detail__radio'>
                    <input
                      type='radio'
                      name={`question-${sensor.sensorName}`}
                      value='no'
                      checked={sensor.sensorAnswer === 'not-equipped'}
                      onChange={() => onAnswer && onAnswer(sensor.sensorName, 'not-equipped')}
                    />
                    <span>No</span>
                  </label>
                </div>
                <span
                  className='adas-detail__reset-link'
                  onClick={() => onAnswer && onAnswer(sensor.sensorName, null)}
                >
                  Reset
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {answered.length > 0 && (
        <div className='adas-detail__safety-card'>
          <h3 className='adas-detail__safety-title'>Safety Systems</h3>
          {answered.map(sensor => (
            <div key={sensor.sensorName} className='adas-detail__safety-row'>
              <span>{sensor.sensorName}</span>
              <span className={`adas-detail__safety-badge ${sensor.sensorAnswer === 'equipped' ? 'equipped' : 'not-equipped'}`}>
                {sensor.sensorAnswer === 'equipped' ? 'Yes' : 'No'}
              </span>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default SafetyFeatures
